import script from "./LeadViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./LeadViewer.vue?vue&type=script&setup=true&lang=js"

import "./LeadViewer.vue?vue&type=style&index=0&id=fcd084ca&scoped=true&lang=css"

import exportComponent from "/builds/izee/leadservice/lead-admin-tool/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fcd084ca"]])

export default __exports__